import request from '@/utils/request'

const CACHE_MS = 23 * 3600 * 1000
const cache = new Map()

export function isOssUrl(url) {
  if (!url || typeof url !== 'string') return false
  return /\.aliyuncs\.com\//i.test(url)
}

/** 去掉过期 query，用作缓存 key 与重新签名 */
export function canonicalOssUrl(url) {
  if (!url || typeof url !== 'string') return url
  return url.trim().split('?')[0]
}

/** 解析库里的 url / photos 字段为字符串数组 */
export function parseImageUrls(raw) {
  if (raw == null || raw === '') return []
  let list = []
  if (typeof raw === 'string') {
    if (raw.startsWith('http') && !raw.trim().startsWith('[')) {
      return [raw.trim()]
    }
    try {
      list = JSON.parse(raw)
    } catch {
      if (raw.includes('http')) {
        return raw.split(',').map((s) => s.trim()).filter(Boolean)
      }
      return []
    }
  } else if (Array.isArray(raw)) {
    list = raw
  } else if (typeof raw === 'object') {
    list = [raw]
  }
  if (!Array.isArray(list)) return []
  return list
    .map((item) => {
      if (typeof item === 'string') return item
      if (item && typeof item.url === 'string') return item.url
      return ''
    })
    .filter(Boolean)
}

function readCache(url) {
  const hit = cache.get(url)
  if (hit && hit.expires > Date.now()) return hit.signed
  return null
}

function writeCache(original, signed) {
  cache.set(original, { signed, expires: Date.now() + CACHE_MS })
}

export async function signOssUrl(url) {
  if (!url || !isOssUrl(url)) return url
  const canonical = canonicalOssUrl(url)
  const cached = readCache(canonical)
  if (cached) return cached
  const res = await request({
    url: 'file/signUrls',
    method: 'post',
    data: { urls: [canonical] },
  })
  const signed = (Array.isArray(res?.data) && res.data[0]) || canonical
  writeCache(canonical, signed)
  return signed
}

export async function signOssUrls(urls) {
  if (!urls?.length) return []
  const result = new Array(urls.length)
  const pending = []
  const pendingIndex = []

  urls.forEach((url, index) => {
    if (!url || !isOssUrl(url)) {
      result[index] = url
      return
    }
    const canonical = canonicalOssUrl(url)
    const cached = readCache(canonical)
    if (cached) {
      result[index] = cached
      return
    }
    pending.push(canonical)
    pendingIndex.push(index)
  })

  if (pending.length) {
    const res = await request({
      url: 'file/signUrls',
      method: 'post',
      data: { urls: pending },
    })
    const signedList = Array.isArray(res?.data) ? res.data : []
    pending.forEach((canonical, i) => {
      const signed = signedList[i] || canonical
      writeCache(canonical, signed)
      result[pendingIndex[i]] = signed
    })
  }

  return result
}

/** 将 photos / material_url 等 JSON 字段转为可展示的签名 URL 列表 */
export async function resolveSignedUrlsFromField(raw) {
  const urls = parseImageUrls(raw)
  return signOssUrls(urls)
}
